﻿export default function($) {
    let kendo = window.kendo,
        ui = kendo.ui,
        widget = ui.Widget,
        wBinders = kendo.data.binders.widget,
        p = $.proxy;

    let DollarValue = widget.extend({
        init: function(element, options) {
            let that = this;
            const thatBase = widget.fn.init.call(that, element, options);
            that.bind('render', e => {
                that.render(e);
            });
            that.bind('dataBound', e => {
                that.dataBound(e);
            });
            that.data = options.data;
            that.metrics = options.metrics;
            that.currentValue = that.options.currentValue;
            that.element.attr('data-role', 'sparkline');
            that._dataSource();
            that._setInner();
        },
        options: {
            name: 'DollarValue',
            useFirst: false,
            useLast: false,
            currentValue: 0.0,
            autoBind: true
        },
        _innerDiv: undefined,
        _change: function(e) {
            let that = this;
            let data = that.dataSource.data();
            that.trigger('dataBound');
        },
        _dataSource: function() {
            let that = this;
            if (that.data !== undefined) {
                that.dataSource = new kendo.data.DataSource(that.data);
            } else that.dataSource = kendo.data.DataSource.create(that.options.dataSource);

            that.dataSource.bind('change', p(that._change, that));
            if (that.options.autoBind === true) that.dataSource.read();
        },
        refresh: function() {
            let that = this;
            that.dataSource.fetch();
            if (that.options.useFirst && that.data !== undefined) {
                that.currentValue = that.data[0];
            }
            if (that.options.useLast && that.data !== undefined) {
                const lastIndex = that.data.length - 1;
                that.currentValue = that.data[lastIndex];
            }
            that.trigger('render');
        },
        dataBound: function(e) {
            let that = this;
            if (that.options.dataBound !== undefined) that.options.dataBound(e);
        },
        render: function(e) {
            const that = this;
            that._setInner();
            if (that.options.render !== undefined) that.options.render(e);
        },
        _setInner: function() {
            let that = this;
            if (that._innerDiv === undefined) {
                const divElement = document.createElement('div');
                that._innerDiv = divElement;
                that.element.append(that._innerDiv);
            }
            that._innerDiv.innerText = `${kendo.toString(that.currentValue, 'c0')}`;
            $(that._innerDiv).addClass('flex justify-center items-start').wrapInner( '<strong></strong>' );
        }
    });
    ui.plugin(DollarValue);
}
